var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-container"},[_c('el-menu-item',{attrs:{"index":'/product/profile/'+_vm.item.id}},[_c('i',{staticClass:"right_icon"}),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.item.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }